import { render, staticRenderFns } from "./manage-alternateemail.vue?vue&type=template&id=fc3d7f12&scoped=true&"
import script from "./manage-alternateemail.vue?vue&type=script&lang=tsx&"
export * from "./manage-alternateemail.vue?vue&type=script&lang=tsx&"
import style0 from "./manage-alternateemail.vue?vue&type=style&index=0&id=fc3d7f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3d7f12",
  null
  
)

export default component.exports